module.exports = __webpack_public_path__ + "img/image-slider-02.ea384b9e.png";